/* eslint-disable import/no-unresolved */
import { readAuthCache } from '@vuejs/utils/authCache';

/**
 * Identyfikatory uzytkownika dla narzedzi zewnetrznych (GA4, Algolia, Recombee).
 *
 * Ciasteczko sesji Laravela nie moze tam trafiac - jego wartosc wystarcza do
 * przejecia sesji. Zamiast niego: id klienta (zalogowany) albo losowy,
 * trwaly identyfikator przegladarki (anonimowy).
 */

const ANONYMOUS_ID_KEY = 'sv_anonymous_id';

const randomId = () => {
    if (window.crypto?.randomUUID) {
        return window.crypto.randomUUID();
    }

    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

export const getAnonymousId = () => {
    try {
        let id = localStorage.getItem(ANONYMOUS_ID_KEY);

        if (!id) {
            id = randomId();
            localStorage.setItem(ANONYMOUS_ID_KEY, id);
        }

        return id;
    } catch {
        return null;
    }
};

/** Id klienta z cache /api/auth/me - tylko gdy wpis nalezy do biezacej sesji. */
export const getCustomerId = () => {
    const cached = readAuthCache();

    if (!cached?.sameSession || !cached.user?.id) {
        return null;
    }

    return String(cached.user.id);
};
